module.exports = __webpack_public_path__ + "img/grenada.bb12670.webp";